module.exports = __webpack_public_path__ + "img/essenza.afcaccb5.png";